import { useQuery } from '@tanstack/react-query'
import { getJobAttempts } from '../lib/endpoints/jobs'
import { qk } from '../lib/queryKeys'
import { isTerminal } from '../lib/jobStatus'
import { pollInterval, POLL_ACTIVE_MS } from '../lib/pollBackoff'
import type { JobStatus } from '../lib/schemas'

export function useJobAttempts(id: string, status: JobStatus) {
  return useQuery({
    queryKey: qk.jobAttempts(id, status),
    queryFn: () => getJobAttempts(id),
    refetchInterval: (query) =>
      pollInterval(
        query.state.error,
        (!isTerminal(status) ||
          (query.state.data?.recovery != null &&
            query.state.data.recovery.phase !== 'finished')) &&
          POLL_ACTIVE_MS,
      ),
    staleTime: 0,
  })
}
